import { BookedLegDocumentUpdateInt, PassengerUpdateDocumentInt } from "@app/interfaces/requiredDocuments.interface";
import { Trip } from "./response/viewDocuments.model";
import { Reservation } from "./reservation.model";

class Address {
  city: string;
  country: string;
  state: string;
  street: string;
  zipCode: string;

  constructor(city: string, country: string, state: string, street: string, zipCode: string) {
    this.city = city;
    this.country = country;
    this.state = state;
    this.street = street;
    this.zipCode = zipCode;
  }
}

class PhoneNumber {
  country: string;
  number: string;
  type: string;

  constructor(country: string, number: string, type: string) {
    this.country = country;
    this.number = number;
    this.type = type;
  }
}

class EmergencyContact {
  fullName: string;
  givenNames: string;
  phoneNumber: PhoneNumber;
  refused: boolean;
  relation: string;
  surname: string;

  constructor(fullName: string, givenNames: string, phoneNumber: PhoneNumber, refused: boolean, relation: string, surname: string) {
    this.fullName = fullName;
    this.givenNames = givenNames;
    this.phoneNumber = phoneNumber;
    this.refused = refused;
    this.relation = relation;
    this.surname = surname;
  }
}

class PassengerId {
  id: string;
  segmentCode: string;

  constructor(id: string, segmentCode: string) {
    this.id = id;
    this.segmentCode = segmentCode;
  }
}

class PermanentResidentCard {
  expirationDate: string;
  issueCountry: string;
  nationality: string;
  number: string;
  residentScanned: boolean;

  constructor(expirationDate: string, issueCountry: string, nationality: string, number: string, residentScanned: boolean) {
    this.expirationDate = expirationDate;
    this.issueCountry = issueCountry;
    this.nationality = nationality;
    this.number = number;
    this.residentScanned = residentScanned;
  }
}

class Visa {
  applicableCountryCode: string;
  birthPlace: string;
  expirationDate: string;
  issueCity: string;
  issueDate: string;
  number: string;
  visaScanned: boolean;

  constructor(applicableCountryCode: string, birthPlace: string, expirationDate: string, issueCity: string, issueDate: string, number: string, visaScanned: boolean) {
    this.applicableCountryCode = applicableCountryCode;
    this.birthPlace = birthPlace;
    this.expirationDate = expirationDate;
    this.issueCity = issueCity;
    this.issueDate = issueDate;
    this.number = number;
    this.visaScanned = visaScanned;
  }
}

export interface PassportInfoInt {
  firstName?: string;
  lastName?: string;
  gender?: string;
  birthDate?: string;
  expirationDate: string;
  issuingCountry: string;
  nationality: string;
  documentNumber: string;
  passportScanned: boolean;
}

export class PassengerDocuments {
  birthDate: string;
  destinationAddress: Address;
  email: string[];
  emergencyContact: EmergencyContact;
  ffNumber: string;
  ffProgram: string;
  firstName: string;
  gender: string;
  lastName: string;
  passengerIds: PassengerId[];
  passengerNameNumber: string;
  passport: PassportInfoInt;
  permanentResidentCard: PermanentResidentCard;
  phone: PhoneNumber[];
  selectedForCheckin: boolean;
  type: string;
  visa: Visa;
  ktn:any;
  redress:any;
  residenceAddress:any;
  contactTracing:any;
  constructor(
    firstName?: string,
    lastName?: string,
    gender?: string,
    birthDate?: string,
    passengerNameNumber?: string,
    selectedForCheckin?: boolean,
    destinationAddress?: Address,
    email?: string[],
    emergencyContact?: EmergencyContact,
    ffNumber?: string,
    ffProgram?: string,
    passengerIds?: PassengerId[],
    passport?: any,
    permanentResidentCard?: PermanentResidentCard,
    phone?: PhoneNumber[],
    type?: string,
    visa?: Visa,
    residenceAddress?: any,
    contactTracing?:any

  ) {
    this.birthDate = birthDate || null;
    this.destinationAddress = destinationAddress || null;
    this.email = email || [];
    this.emergencyContact = emergencyContact || null;
    this.ffNumber = ffNumber || null;
    this.ffProgram = ffProgram || null;
    this.firstName = firstName || '';
    this.gender = gender || null;
    this.lastName = lastName || '';
    this.passengerIds = passengerIds || null;
    this.passengerNameNumber = passengerNameNumber || '';
    this.passport = passport || null;
    this.permanentResidentCard = permanentResidentCard || null;
    this.phone = phone || null;
    this.selectedForCheckin = selectedForCheckin || true;
    this.type = type || '';
    this.visa = visa || null;
    this.residenceAddress = residenceAddress || null;
    this.contactTracing.email= contactTracing;
  }
}



export class RequestUpdateDocuments {
  bookedLegCollection: BookedLegDocumentUpdateInt[];
  passengers: PassengerUpdateDocumentInt[];
  reservationCode: string;
  tripType: string;
  travelPartyId: string;
  trips: Trip[];

  constructor(bookedLegCollection: BookedLegDocumentUpdateInt[], passenger: PassengerUpdateDocumentInt[], reservation: Reservation, tripType: string) {
    this.bookedLegCollection = bookedLegCollection;
    this.passengers = passenger;
    this.reservationCode = reservation.pnr;
    this.tripType = tripType;
    if(reservation.codeShare){
      this.travelPartyId = reservation.travelPartyId;
      this.trips = reservation.trips;
    } 
  }
}

